let timestampIndex = 0;
/**
 * 对js脚本进行异步加载
 * @param  {String} url     请求地址
 * @param  {Object} options 扩展参数，参数内容如下
 * @param {Object} data 需要传给服务器的参数，
 * 注意：参数会进行encodeURIComponent编码
 * @param {Number || Boolean} cache 只能是数字类型，如果是false，则不会拼接该参数
 * @param {Number} timeout jsonp超时时间，默认为10000毫秒
 */

export default function(
    url,
    { data = {}, cache = `${new Date().valueOf()}${timestampIndex++}`, timeout = 10000 } = {},
) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            reject({ type: 'timeout', msg: `请求超时${timeout}` });
        }, timeout);

        // 对参数进行处理
        const params = [];
        // 只支持对象传入

        if (typeof data === 'object') {
            for (const key of Object.keys(data)) {
                params.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
            }
        } else {
            reject({ type: 'typeError', msg: 'data必须为一个对象' });

            return;
        }

        if (cache) {
            params.push(`_=${cache}`);
        }

        if (url.includes('?')) {
            url = `${url}&${params.join('&')}`;
        } else {
            url = `${url}?${params.join('&')}`;
        }

        const insertScript = document.createElement('script');

        insertScript.src = url;

        insertScript.onload = insertScript.onreadystatechange = function onreadystatechange() {
            if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                resolve({ type: 'success', msg: '脚本加载成功' });
                clearTimeout(timer);
                insertScript.onload = insertScript.onreadystatechange = null;
                insertScript.parentNode.removeChild(insertScript);
            }
        };

        insertScript.onerror = () => {
            clearTimeout(timer);
            reject({ type: 'scriptLoaderror', msg: '脚本加载错误' });
        };

        const oScript = document.getElementsByTagName('script')[0];

        oScript.parentNode.insertBefore(insertScript, oScript);
    });
}
